// @flow

import type { WizardPage } from '@chatchamp/chatchamp-types'

export function getProgressBarData (wizardPages: Array<WizardPage>, questionSelectionPath: number[], currentWizardPageIndex: number, isLastPage: boolean): Object {
  const visitedPages = getProgressBarItems(wizardPages, questionSelectionPath, currentWizardPageIndex)
  const progress = calculateProgress(visitedPages, wizardPages, questionSelectionPath, isLastPage)
  return { visitedPages, progress }
}

function getProgressBarItems (wizardPages: Array<WizardPage>, questionSelectionPath: number[], currentWizardPageIndex: number): Object {
  let visitedPages = questionSelectionPath.map(wizardPageId => {
    return wizardPages.find(w => w.id === +wizardPageId)
  }, [])
  const currentWizardPage = wizardPages.find((_, index) => index === currentWizardPageIndex)

  if (visitedPages.length === 0) {
    if (currentWizardPage) visitedPages.push(currentWizardPage)
  } else {
    const currentWizardPageIndex = visitedPages.findIndex(w => w?.id === currentWizardPage?.id)
    if (currentWizardPageIndex > -1) {
      visitedPages = visitedPages.slice(0, currentWizardPageIndex + 1)
    } else {
      visitedPages.push(currentWizardPage)
    }
  }

  return visitedPages
}

function calculateProgress (visitedPages: Array<Object>, wizardPages: Array<WizardPage>, questionSelectionPath: number[], isLastPage: boolean): number {
  const sortedDepths = [...wizardPages].sort((a, b) => a.depth - b.depth)
  let highestDepth = sortedDepths[wizardPages.length - 1]?.depth || 0
  const visitedPageCount = visitedPages.length - 1
  if (visitedPageCount === highestDepth && !isLastPage) highestDepth = visitedPageCount + 1
  if (visitedPageCount > highestDepth) highestDepth = visitedPageCount + 1

  let progress = Math.ceil(visitedPageCount * 100 / highestDepth)
  if (progress > 100 && !isLastPage) progress = 100
  if (progress > 100 || isLastPage) progress = 100
  if (isNaN(progress)) progress = 0

  return progress
}

export function progressBarItemLabelWidth (progress: number, progressBarWidth: number, totalItems: number): number {
  const partialWidth = progress * progressBarWidth / 100
  return Math.round(partialWidth / totalItems)
}
